<template>
	<div class="timeline" :style="styles">
		<div class="title-timeline">
			<span>{{ title }}</span>
		</div>
		<div v-for="row of data" :key="row.id" class="timeline-row">
			<div class="timeline-icon">
				<div
					class="timeline-icon_container"
					:style="{
						backgroundColor: row.icon.backgroundColor,
						color: row.icon.color,
					}"
				>
					<feather :type="row.icon.type" size="18px" />
				</div>
			</div>
			<div class="timeline-content">
				<div :style="{ color: estilos.title.color }" class="timeline-content_top">
					<div :style="{ textTransform: 'uppercase' }">
						<span>{{ row.empresa || row.title || row.cargo }}</span>
						<slot :row="row" name="subtitle" />
					</div>
					<div>
						{{ returnElapsedTime(row.created_at || row.timestamp || row.updated_at || row.dt_fim) }}
					</div>
				</div>
				<div class="timeline-content-details">
					<slot :row="row" name="details" class="timeline-content-details" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import cookie from 'vue-cookie';
import global from '../../../mixins/global';

export default {
	mixins: [global],
	props: {
		title: {
			type: String,
			default: 'Timeline',
		},
		width: {
			type: String,
			default: '100%',
		},
		estilos: {
			type: Object,
			default: () => ({ title: { color: '#a4abc5' } }),
		},
		marginBottom: {
			type: String,
			default: '0',
		},
		marginTop: {
			type: String,
			default: '0',
		},
		data: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			token: cookie.get('admtoken'),
		};
	},
	computed: {
		styles() {
			return {
				marginBottom: this.marginBottom,
				width: this.width,
				marginTop: this.marginTop,
			};
		},
	},
	methods: {
		getTimelineIcon(situacao) {
			switch (situacao) {
				case 2:
					return {
						icon: 'x',
						color: 'rgb(249, 58, 90)',
						backgroundColor: 'rgb(249, 58, 90, 0.08)',
					};
				case 1:
					return {
						icon: 'shield',
						color: 'rgb(0, 91, 234)',
						backgroundColor: 'rgb(0, 91, 234, 0.08)',
					};
				default:
					return { icon: 'check', color: '#FFF ', backgroundColor: 'rgb(0, 117, 26, 0.08)' };
			}
		},
	},
};
</script>

<style scoped>
.title-timeline {
	font-weight: bold;
	margin-bottom: 25px;
}
.timeline {
	background-color: #fff;
	border-radius: 5px;
	padding: 20px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
}
.timeline-content-details {
	display: flex;
	flex-direction: column;
	font-size: 12px;
}
.timeline-content-row {
	display: flex;
	flex-direction: column;
	margin-bottom: 10px;
}
.timeline-row {
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin: 10px 0;
}
.timeline-content {
	display: flex;
	width: 96%;
	flex-direction: column;
}
.link {
	color: #1761fd !important;
}
.timeline-icon {
	width: 4%;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
}
.timeline-icon::before {
	content: '';
	position: absolute;
	bottom: 0;
	top: 42px;
	left: 18px;
	border-left: 2px dotted #e3ebf6;
}
.timeline-icon_container {
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	box-shadow: 0px 0px 1px 0.25px;
	border: 2px solid #fff;
}
.timeline-content_top {
	width: 100%;
	height: 40px;
	margin-top: 7px;
	display: flex;
	font-weight: bold;
	font-size: 12px;
	flex-direction: row;
	justify-content: space-between;
}
</style>

